import React from 'react';
import { useNavigate } from 'react-router-dom';
import './SafetyGuidelines.css';

function SafetyGuidelines() {
  const navigate = useNavigate();

  return (
    <div className="safety-page">
      <button className="back-btn" onClick={() => navigate('/')}>
        <span className="back-arrow">←</span> Back to Home
      </button>

      <div className="safety-container">
        <header className="safety-header">
          <span className="safety-badge">Community Trust</span>
          <h1>Safety & Trading Guidelines</h1>
          <p className="safety-subtitle">
            Simple, practical practices to ensure every buy and sell experience on Salekiya is safe, transparent, and secure.
          </p>
        </header>

        {/* Essential Rules Banner */}
        <div className="golden-rules">
          <div className="rule-item">
            <span className="rule-icon">🤝</span>
            <div>
              <strong>Meet in Person</strong>
              <p>Always inspect products before exchanging any payment.</p>
            </div>
          </div>
          <div className="rule-item">
            <span className="rule-icon">🚫</span>
            <div>
              <strong>No Advance Deposits</strong>
              <p>Never send token money or courier fees upfront.</p>
            </div>
          </div>
          <div className="rule-item">
            <span className="rule-icon">📍</span>
            <div>
              <strong>Public Locations</strong>
              <p>Choose well-lit, crowded public spaces for meetups.</p>
            </div>
          </div>
        </div>

        {/* Section 1: For Buyers */}
        <section className="safety-section">
          <h2>Tips for Buyers</h2>
          <div className="tips-list">
            <div className="tip-card">
              <h3>1. Test Before You Pay</h3>
              <p>
                Whether buying an iPhone, laptop, or bike, turn on the device, check battery health, test ports, verify IMEI numbers, and take a quick spin before completing the transaction.
              </p>
            </div>

            <div className="tip-card">
              <h3>2. Beware of Unrealistic Prices</h3>
              <p>
                If a top-tier brand-new device is priced dramatically below market value, exercise extreme caution. Unrealistic prices are often used to lure buyers into advance payment scams.
              </p>
            </div>

            <div className="tip-card">
              <h3>3. Avoid "Delivery First" Offers</h3>
              <p>
                Do not accept arrangements where the seller asks you to pay for courier/shipping fees upfront before they send the product. Salekiya is built for local, hand-to-hand transactions.
              </p>
            </div>
          </div>
        </section>

        {/* Section 2: For Sellers */}
        <section className="safety-section">
          <h2>Tips for Sellers</h2>
          <div className="tips-list">
            <div className="tip-card">
              <h3>1. Verify Instant Payment In Your Account</h3>
              <p>
                When accepting UPI (GPay, PhonePe, Paytm), always verify the credited amount directly inside your own banking app. Never rely solely on screenshot proofs shown by the buyer.
              </p>
            </div>

            <div className="tip-card">
              <h3>2. Never Enter Your UPI PIN to "Receive" Money</h3>
              <p>
                Receiving money through UPI never requires entering your PIN or scanning a "receive money" QR code. If anyone asks you to enter your PIN, it is an attempt to withdraw funds from your account.
              </p>
            </div>

            <div className="tip-card">
              <h3>3. Protect Your Home Privacy</h3>
              <p>
                For smaller items like phones, gadgets, or clothing, avoid inviting strangers directly to your home. Meet near a local metro station, cafe, or market center.
              </p>
            </div>
          </div>
        </section>

        {/* Section 3: Red Flags */}
        <section className="safety-section warning-section">
          <h2>🚩 Warning Signs of Fraud</h2>
          <ul className="warning-list">
            <li>Users insisting on communicating via third-party channels immediately to avoid in-app safety logs.</li>
            <li>Claims of being out of state or in the military requiring urgent wire transfers before delivery.</li>
            <li>Requests for one-time passwords (OTPs), bank passwords, or debit card CVVs.</li>
            <li>Pressure tactics urging you to transfer money within minutes to hold an item.</li>
          </ul>
        </section>

        {/* Support Section */}
        <div className="report-box">
          <h3>Spot Something Suspicious?</h3>
          <p>
            If you encounter fraudulent listings, harassment, or suspicious requests in chat, report the listing immediately or notify our team at{' '}
            <a href="mailto:info@salekiya.com">info@salekiya.com</a>.
          </p>
        </div>
      </div>
    </div>
  );
}

export default SafetyGuidelines;